import React from "react";
import { IconButton } from "../../../../../src";
import { Button } from "../../../Button";
import {
  BetCardFooter,
  FooterButton,
  TooltipContainer
} from "./styled-components";
import { Icon } from "../../../Icon";
import type { WagerCardFooterProps } from "./types";
import Tooltip from "../../../Tooltip";

const WagerCardFooter = ({
  isBetActive,
  hasSocialShare,
  hasRepeatButton,
  hasCancelButton,
  isDetailsOpened,
  onRepeatPress,
  onDetailsPress,
  onCancelWager,
  onPressShareWager,
  isXsellBlacklistedBet = false
}: WagerCardFooterProps) => (
  <BetCardFooter>
    {hasSocialShare && (
      <FooterButton data-qa-label="myBets-social-share">
        <IconButton
          variant="tertiary"
          size="s"
          iconSize="s"
          qaLabel="social-share-bet-btn"
          onPress={onPressShareWager}
          iconName="popout"
          tertiaryColor="grey.900"
        />
      </FooterButton>
    )}
    {hasRepeatButton && (
      <FooterButton isRepeatButton>
        {isXsellBlacklistedBet && (
          <TooltipContainer>
            <Tooltip
              content="Repeat bet is currently unavailable for this bet type."
              qaLabel="tooltip-repeat-bet-disabled"
              placement="top-right"
              layer={9999}
            >
              <Icon qaLabel="icon-info-repeat-tooltip" name="info" size="s" />
            </Tooltip>
          </TooltipContainer>
        )}
        <Button
          variant="tertiary"
          size="m"
          qaLabel="myBets-betTicked-repeatButton"
          onClick={onRepeatPress}
          icon={!isXsellBlacklistedBet ? "repeat" : undefined}
          isDisabled={isXsellBlacklistedBet}
        >
          {isBetActive ? "Repeat bet" : "Re-Bet"}
        </Button>
      </FooterButton>
    )}
    {hasCancelButton && (
      <FooterButton isCancelButton>
        <Button
          variant="tertiaryDestructive"
          size="m"
          qaLabel="myBets-betTicked-cancelButton"
          onClick={onCancelWager}
          icon="trash"
        >
          Cancel
        </Button>
      </FooterButton>
    )}
    <FooterButton isDetailsButton isWagerCancelable={hasCancelButton}>
      <Button
        variant="tertiary"
        size="m"
        qaLabel="myBets-betTicked-detailsButton"
        onClick={onDetailsPress}
        icon={!isDetailsOpened ? "chevronDown" : "chevronUp"}
        iconPosition="end"
      >
        {isDetailsOpened ? "Hide details" : "Show details"}
      </Button>
    </FooterButton>
  </BetCardFooter>
);

export default WagerCardFooter;
